import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_BACKEND_URL });

// holiday_backend/middleware reads "<sessionId>&<organizationId>" from the Bearer token.
const config = (s) => ({ headers: { Authorization: `Bearer ${s.sessionId}&${s.organizationId}` } });

const post = (path, s, extra = {}) => api.post(path, { ...s, ...extra }, config(s)).then((r) => r.data);

export const fetchRoadiesState = (s) => post('/roadies/state', s);
export const startRoadies = (s) => post('/roadies/start', s);
export const submitRoadies = (s, round, score, timer) => post('/roadies/submit', s, { round, score, timer });
export const linkRoadiesReport = (s, reportId) => post('/roadies/linkReport', s, { reportId });
export const fetchRoadiesLeaderboard = (s) => post('/roadies/leaderboard', s);
